import {Box, Divider, Grid, Typography} from "@mui/material";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

// Общие блоки шага summary конструкторов кампаний и AB-тестов: секции, строки "поле: значение", аудитории.

export const formatMsk = (value) => value ? dayjs(value).utcOffset(180).format('DD.MM.YYYY HH:mm') : null;
const isBlank = (value) => value === undefined || value === null || value === '' || (Array.isArray(value) && value.length === 0);
export const toText = (value) => isBlank(value) ? 'N/A' : (Array.isArray(value) ? value.join(', ') : value.toString());

export const Section = ({title, children}) => (
    <Box sx={{mb: 2}}>
        <Typography variant="h6">{title}</Typography>
        <Divider sx={{mb: 1}}/>
        {children}
    </Box>
);

// "поле: значение" — подпись справа от центра, значение слева от центра (как раньше), один шрифт везде
export const Row = ({label, children}) => (
    <Grid container columnSpacing={2} sx={{py: 0.5}}>
        <Grid item xs={5} sx={{textAlign: 'right', color: 'text.secondary', overflowWrap: 'anywhere'}}>{label}</Grid>
        <Grid item xs={7} sx={{overflowWrap: 'anywhere'}}>{children}</Grid>
    </Grid>
);

export const Fields = ({rows}) => rows.filter(Boolean).map(([label, value]) => (
    <Row key={label} label={label}>{toText(value)}</Row>
));

const formatRange = (paramSet) =>
    `${paramSet.fromIncl || paramSet.fromIncl === null ? '>= ' : '> '}${paramSet.paramFromValue || '∞'} , `
    + `${paramSet.toIncl || paramSet.toIncl === null ? '<= ' : '< '}${paramSet.paramToValue || '∞'}`;

const VALUE_ONLY_OPERATORS = ['offerInProfile', 'offerNotInProfile', 'offerTypeInactiveRule', 'offerTagInactiveRule',
    'offerInactiveRule', 'offerTagNotInProfileRule', 'matchRule', 'notMatchRule'];

// то же содержимое, что и CommonSummary.getAudienceSection, но в общей сетке и шрифте шага
const formatParameter = (paramSet) => {
    if (paramSet.hasOwnProperty('fromIncl') || paramSet.hasOwnProperty('toIncl')) return formatRange(paramSet);
    if (VALUE_ONLY_OPERATORS.includes(paramSet.operator)) return isBlank(paramSet.paramValue) ? 'Null' : toText(paramSet.paramValue);
    if (!isBlank(paramSet.paramValue)) return <>
        <Box component="span" sx={{color: 'text.secondary', mr: 1}}>{paramSet.operator}</Box>{toText(paramSet.paramValue)}
    </>;
    if (paramSet.offsetValue) return `${paramSet.offerId || 'Null'} ${paramSet.offsetValue}`;
    if (paramSet.offset) return `${paramSet.operator || 'Null'} ${paramSet.offerId || 'Null'} ${paramSet.offset}`;
    return 'N/A';
};

export const AudiencesSummary = ({audiences}) => audiences.map(audience => (
    <Box key={audience.name} sx={{mb: 1}}>
        <Row label={<Box component="span" sx={{color: 'text.primary', fontWeight: 600}}>{audience.name}</Box>}/>
        {audience.parameters.map((paramSet, index) => (
            <Row key={index} label={paramSet?.parameterData?.parameterName || '—'}>
                {formatParameter(paramSet)}
            </Row>
        ))}
    </Box>
));
